export class CentricOrderAcceptanceRequest {
    id:number;
    poNumber: string;
    poLine: number;
    itemNo: string;
    buyer: string;
    deliveryDate:string;
    style:string;
    material:string;
    shipToAddress:string;
}